{
  "en": {
    "dressingRoom": {
      "lead": "Put armour and an undersuit together and see the outfit in 3D. Share it by link, or sign in to save it.",
      "slots": {
        "helmet": "Helmet",
        "torso": "Core",
        "arms": "Arms",
        "legs": "Legs",
        "backpack": "Backpack",
        "undersuit": "Undersuit",
        "primary": "Primary",
        "secondary": "Secondary",
        "sidearm": "Sidearm"
      },
      "size": "S%{size}",
      "choose": "Choose…",
      "remove": "Remove",
      "openItem": "Open item page",
      "notFound": "Item not found",
      "noHolo": "No 3D model yet",
      "empty": "Choose a piece for any slot to see the outfit.",
      "pose": "Pose",
      "copyLink": "Copy link",
      "savedOutfits": "Saved outfits",
      "signInToSave": "Sign in to save outfits.",
      "outfitName": "Outfit name",
      "nameTaken": "You already have an outfit with this name.",
      "saveNew": "Save as new outfit",
      "saveChanges": "Save changes",
      "noOutfits": "No saved outfits yet.",
      "pieces": {
        "one": "%{count} piece",
        "other": "%{count} pieces"
      },
      "confirmDelete": "Delete the outfit %{name}?",
      "messages": {
        "saved": "Outfit saved.",
        "saveFailed": "The outfit could not be saved.",
        "deleteFailed": "The outfit could not be deleted.",
        "linkCopied": "Link copied.",
        "copyFailed": "The link could not be copied."
      },
      "groups": {
        "armour": "Armour",
        "weapons": "Weapons",
        "gear": "Gear"
      },
      "hold": "Hold",
      "bodies": {
        "male": "Male",
        "female": "Female"
      },
      "positionPending": "Position not exported yet",
      "fit": {
        "noPort": "%{item} has no slot for this",
        "doesNotFit": "Doesn't fit %{item}",
        "noWornPiece": "Nothing worn has a slot for this"
      },
      "armorSets": {
        "open": "Armour sets",
        "count": {
          "one": "%{count} Set",
          "other": "%{count} Sets"
        }
      },
      "gearHint": "Wear a core, legs or an undersuit to carry grenades, magazines, pens and tools.",
      "gear": {
        "grenade": "Grenade %{number}",
        "magazine": "Magazine %{number}",
        "gadget": "Gadget",
        "medpen": "Medpen %{number}",
        "oxypen": "Oxypen %{number}",
        "utility": "Utility %{number}"
      },
      "saveBlocked": "Fix what is marked above to save this outfit.",
      "storage": {
        "title": "Storage",
        "space": "%{used} of %{capacity}",
        "add": "Add item",
        "fewer": "One fewer",
        "more": "One more",
        "pickerTitle": "Add to %{piece}",
        "problems": {
          "noStorage": "Nothing worn here can hold these items.",
          "overCapacity": "Holds more than this piece has room for.",
          "tooLarge": "Holds an item too large for this piece.",
          "unmeasured": "Holds an item with no measured size."
        },
        "misfit": {
          "unmeasured": "No measured size",
          "tooLarge": "Too large for this piece",
          "noRoom": "Not enough room left"
        }
      },
      "gearNone": "What you are wearing has no gear slots.",
      "gearColumns": {
        "magazine": "Ammo",
        "grenade": "Grenades",
        "medpen": "Medpens",
        "oxypen": "Oxypens"
      }
    }
  }
}
